<script setup lang="ts">
import { computed, nextTick, onMounted, ref } from 'vue'

interface Props {
  placeholder?: string
  type?: string
  modelValue?: string
  autofocus?: boolean
  inputClass?: string
  disabled?: boolean
  textarea?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  placeholder: '',
  type: 'text',
  modelValue: '',
  autofocus: false,
  inputClass: '',
  textarea: false,
})

interface Emits {
  (e: 'update:modelValue', value: string): void
}
const emit = defineEmits<Emits>()

const inputRef = ref(null)

const valueModel = computed({
  get() {
    return props.modelValue
  },
  set(value: string) {
    emit('update:modelValue', value)
  },
})

onMounted(() => {
  nextTick(() => {
    if (props.autofocus && inputRef.value) {
      inputRef.value.focus()
    }
  })
})
</script>

<template>
  <div class="input-wrapper position-relative">
    <input
      v-if="!props.textarea"
      ref="inputRef"
      v-model="valueModel"
      :class="inputClass"
      :type="props.type"
      :placeholder="props.placeholder"
      :disabled="props.disabled"
    />
    <textarea
      v-else
      ref="inputRef"
      v-model="valueModel"
      :class="inputClass"
      :type="props.type"
      :placeholder="props.placeholder"
      :disabled="props.disabled"
    ></textarea>
    <i v-if="valueModel" class="icon fas fa-times" @click="valueModel = ''" />
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;
@import 'frontend_stylesheets/_variables.scss';

.input-wrapper {
  width: 100%;
}

input {
  outline: none;
  border-radius: $input-border-radius;
  border: 1px solid map.get(themeVariables.$colors, outline);
  background: transparent;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04);
  height: 36px;
  padding: 0 32px 0 12px;
  width: 100%;

  // &[disabled] {
  //   background: #E6E6E6;

  //   .erebus-app[data-theme='dark'] & {
  //     background: red;
  //   }
  // }

  &:focus {
    border-color: var(--custom-primary) !important;
    border-width: 2px;
  }
}

textarea {
  outline: none;
  min-height: 70px;
  border-radius: $input-border-radius;
  border: 1px solid map.get(themeVariables.$colors, outline);
  background: transparent;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04);
  // height: 36px;
  padding: 8px 24px 0 12px;
  width: 100%;
  &[disabled] {
    background: #f8f8f8;
    opacity: 0.5;
  }
  &:focus {
    border-color: var(--custom-primary);
    border-width: 2px;
  }
}

.icon {
  position: absolute;
  top: 0;
  right: 2px;
  height: 36px;
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: hsl(200deg, 4%, 72%);
  border-radius: $input-border-radius;
  cursor: pointer;

  &:hover {
    color: hsl(206deg, 58%, 55%);
  }
}
</style>
